import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';

const StyleInput = withStyles((theme) => ({
    root: {
      borderRadius: 4,
      fontFamily: 'Kanit',
      borderColor: 'black',
      borderWidth: '2px',
      '&$checked': {
        color: '#000',
        fontFamily: 'Kanit',
      }
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: 'white',
        border: '1px solid #ced4da',
        '&:focus': {
        borderRadius: 4,
        }
    }
}))(InputBase);

const StyleSelect = withStyles((theme) => ({
    root: {
      borderRadius: 4,
      backgroundColor: 'white',
      color: '#000',
      padding: '0',
      padding: '10.5px',
      fontFamily: 'Kanit',
      borderColor: 'black',
      borderWidth: '2px',
    },
    disabled: {
        backgroundColor: '#CCC',
    }
}))((props) => <Select color="default" {...props} />);

function SelectComponent({name, title, value, onChange, defaultValue, options, disabled, style}) {
  return (
    <div className="flex row" style={style}>
        <div>{title}</div>
        <FormControl variant="outlined" style={{width: '100%'}} >
            <StyleSelect
            id={name}
            name={name}
            displayEmpty
            value={value}
            onChange={onChange}
            disabled={disabled}
            input={<StyleInput />}
            >
                <MenuItem 
                    value="" 
                    disabled
                >
                    {defaultValue}
                </MenuItem>
                {
                    options.map((val, index)=>{
                        return(
                            <MenuItem 
                                value={val.value}
                                key={index}
                            >
                                {val.label}
                            </MenuItem>
                        )
                    })
                }
            </StyleSelect>
        </FormControl>
    </div>
  );
}

export default SelectComponent;
